import BookDemoForm, { getServerSidePropsFunc } from './bookafreehomedemo';
export default BookDemoForm;
export const getServerSideProps = getServerSidePropsFunc('/corporate-gifts-and-bulk-discounts');
